import React, { FormEvent, KeyboardEvent } from "react";
import { Box, InputBase, SxProps, Theme } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { CONTROL_HEIGHT, NJIM, searchFieldSx } from "../../../../theme/njimTheme";

interface SearchFieldProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  onSubmit?: () => void;
  disabled?: boolean;
  sx?: SxProps<Theme>;
  /** When false, skip the wrapping form. Default true so Enter never reloads the page. */
  asForm?: boolean;
}

const SearchField: React.FC<SearchFieldProps> = ({
  value,
  onChange,
  placeholder,
  onSubmit,
  disabled,
  sx,
  asForm,
}) => {
  const useForm = asForm ?? true;

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key !== "Enter") return;
    e.preventDefault();
    if (!disabled) onSubmit?.();
  };

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    if (disabled) return;
    onSubmit?.();
  };

  const field = (
    <Box sx={{ ...searchFieldSx, height: CONTROL_HEIGHT, ...sx }}>
      <SearchIcon sx={{ color: NJIM.textMuted, fontSize: 18, flexShrink: 0 }} />
      <InputBase
        fullWidth
        value={value}
        disabled={disabled}
        placeholder={placeholder}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={useForm ? undefined : handleKeyDown}
        sx={{ fontSize: 14, flex: 1, minWidth: 0 }}
        inputProps={{ "aria-label": placeholder }}
      />
    </Box>
  );

  if (!useForm) return field;

  return (
    <Box
      component="form"
      onSubmit={handleSubmit}
      sx={{ display: "flex", flex: 1, minWidth: 0, width: "100%" }}
    >
      {field}
    </Box>
  );
};

export default SearchField;
